import EpiApiClient from "@/services/serviceClients/epiApiClient";
import  { GAF_QUICKMEASURE_API_PATH, GAF_IMPORT_REPORT_API_PATH, GAF_ADD_INTEGRATION_API_PATH } from "@/config/constants"

const handleResponse = (response) => {
  if (response.data && response.data.Success) {
    return response.data;
  }
  throw new Error(response.data.ErrorMessage || "API Error");
};

export const gafService = {
  async getAccount(emailAddress) {
    try {
      const response = await EpiApiClient.get(
        `${GAF_QUICKMEASURE_API_PATH}GetAccount/${emailAddress}`,
        { handleError: false }
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error_description || "API error",
        data: {},
      };
    }
  },

  async connectIntegration(payload) {
    const response = await EpiApiClient.post(
      `${GAF_ADD_INTEGRATION_API_PATH}`,
      payload
    );
    return handleResponse(response);
  },

  async searchReports(payload) {
    const response = await EpiApiClient.post(
      `${GAF_QUICKMEASURE_API_PATH}SearchReports`,
      payload
    );
    return handleResponse(response);
  },

  async orderReport(payload) {
    try {
      const response = await EpiApiClient.post(
        `${GAF_QUICKMEASURE_API_PATH}OrderReport`,
        payload,
        { handleError: false }
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error_description || 'API error',
        data: {},
      };
    }
  },

  async importReport(reportId, reportData) {
    const response = await EpiApiClient.post(`${GAF_IMPORT_REPORT_API_PATH}`, {
      ReportId: reportId,
      ...reportData,
    });
    return handleResponse(response);
  },
};
